import React, { /*useCallback,*/ useState, useEffect, Fragment } from "react";
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import axios from 'axios';
import AuthService from '../../Auth/AuthService.js';
import { settings } from './../../Helpers/Settings.js';
//import settings from './../../Settings.json';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2'
import PageTitle from "../../Components/PageTitle.js";
import { decodeToken, isExpired } from "react-jwt";

const Rol = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [yetkiGor, setYetkiGor] = useState(null);
    const [yetkiEkle, setYetkiEkle] = useState(false);
    const [yetkiDegistir, setYetkiDegistir] = useState(false);
    const [yetkiSil, setYetkiSil] = useState(false);

    const [currentId, setCurrentId] = useState(0);
    const [rol, setRol] = useState('');

    const [data, setData] = useState([]);
    const [yetkiListVerilmeyen, setYetkiListVerilmeyen] = useState([]);
    const [yetkiListVerilen, setYetkiListVerilen] = useState([]);
    const [checkAllVerilmeyen, setCheckAllVerilmeyen] = useState(false);
    const [checkAllVerilen, setCheckAllVerilen] = useState(false);

    const yetkiListVerilmeyenOnUpdate = (index, checked) => {
        const yetkiListVerilmeyenTemp = [...yetkiListVerilmeyen];
        yetkiListVerilmeyenTemp[index].checked = checked;
        setYetkiListVerilmeyen(yetkiListVerilmeyenTemp);
    };

    const yetkiListVerilenOnUpdate = (index, checked) => {
        const yetkiListVerilenTemp = [...yetkiListVerilen];
        yetkiListVerilenTemp[index].checked = checked;
        setYetkiListVerilen(yetkiListVerilenTemp);
    };

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);
            setShow(false);
            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    useEffect(() => {
        getAcilisData();
    }, []);

    const handleCheckAllVerilmeyen = () => {
        setCheckAllVerilmeyen(!checkAllVerilmeyen);

        const temp = yetkiListVerilmeyen;

        temp.forEach((item) => {
            item.checked = !checkAllVerilmeyen;
        });

        setYetkiListVerilmeyen(temp);
    }

    const handleCheckAllVerilen = () => {
        setCheckAllVerilen(!checkAllVerilen);

        const temp = yetkiListVerilen;

        temp.forEach((item) => {
            item.checked = !checkAllVerilen;
        });

        setYetkiListVerilen(temp);
    }

    const getAcilisData = async () => {
        if (await tokenYenile() === false) {
            return;
        }

        let tempYetkiGor = await AuthService.getYetkiKontrolByYetki("Ayarlar - Roller - Gör");

        setYetkiGor(tempYetkiGor);

        if (tempYetkiGor === true) {
            setYetkiEkle(await AuthService.getYetkiKontrolByYetki("Ayarlar - Roller - Ekle"));
            setYetkiDegistir(await AuthService.getYetkiKontrolByYetki("Ayarlar - Roller - Değiştir"));
            setYetkiSil(await AuthService.getYetkiKontrolByYetki("Ayarlar - Roller - Sil"));
            await getData();
        }
    }

    const getData = async () => {
        try {
            const result = await axios.get(settings.ApiUrl + 'Rol/GetRolList', { headers: AuthService.getHeaders() });

            if (result) {
                setData(result.data.value);
            }
        } catch (error) {
            toast.error(error);
        }
    }

    const getYetkiListVerilmeyen = async (id) => {
        try {
            const result = await axios.get(settings.ApiUrl + 'Rol/GetYetkiListVerilmeyenByRolId/' + id, { headers: AuthService.getHeaders() });

            if (result) {
                setYetkiListVerilmeyen(result.data.value);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getYetkiListVerilen = async (id) => {
        try {
            const result = await axios.get(settings.ApiUrl + 'Rol/GetYetkiListVerilenByRolId/' + id, { headers: AuthService.getHeaders() });

            if (result) {
                setYetkiListVerilen(result.data.value);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const Saga = () => {
        const karsiyaAtilacaklar = yetkiListVerilmeyen.filter(item => item.checked === true);
        const kalacaklar = yetkiListVerilmeyen.filter(item => item.checked === false);

        const atilacaklarlaBeraberYeniListe = [...yetkiListVerilen, ...karsiyaAtilacaklar];

        setYetkiListVerilmeyen(kalacaklar);
        setYetkiListVerilen(atilacaklarlaBeraberYeniListe);
    }

    const Sola = () => {
        const karsiyaAtilacaklar = yetkiListVerilen.filter(item => item.checked === true);
        const kalacaklar = yetkiListVerilen.filter(item => item.checked === false);

        const atilacaklarlaBeraberYeniListe = [...yetkiListVerilmeyen, ...karsiyaAtilacaklar];

        setYetkiListVerilen(kalacaklar);
        setYetkiListVerilmeyen(atilacaklarlaBeraberYeniListe)
    }

    const Ekle = async () => {
        if (await tokenYenile() === false) {
            return;
        }

        setCurrentId(0);
        setRol("");
        getYetkiListVerilmeyen(0);
        getYetkiListVerilen(0);

        handleShow();
    }

    const Degistir = async (id) => {
        if (await tokenYenile() === false) {
            return;
        }

        try {
            const result = await axios.get(settings.ApiUrl + 'Rol/GetRol/' + id, { headers: AuthService.getHeaders() });

            if (result) {
                setCurrentId(id);
                setRol(result.data.value.rol);
                getYetkiListVerilmeyen(id);
                getYetkiListVerilen(id);

                handleShow();
            }
        } catch (error) {
            toast.error(error);
        }
    }

    const Sil = async (id) => {
        if (await tokenYenile() === false) {
            return;
        }

        Swal.fire({
            title: "Uyarı",
            text: "Kayıt silinecek, emin misiniz?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sil",
            cancelButtonText: "Vazgeç"
        }).then(async (resultSwal) => {
            if (resultSwal.isConfirmed) {
                try {
                    const resultGet = await axios.get(settings.ApiUrl + 'Rol/GetRol/' + id, { headers: AuthService.getHeaders() });

                    if (resultGet) {
                        const resultDelete = await axios.post(settings.ApiUrl + 'Rol/DeleteRol/', [resultGet.data.value], { headers: AuthService.getHeaders() });

                        if (resultDelete) {
                            if (resultDelete.data.success === true) {
                                getData();
                                toast.success("Silindi");
                            } else {
                                toast.error(resultDelete.data.message);
                            }
                        }
                    }
                } catch (error) {
                    toast.error(error);
                }
            }
        });
    }

    const Kaydet = async () => {
        if (await tokenYenile() === false) {
            return;
        }

        if (rol === "") {
            Swal.fire({ title: "Hata", text: "Lütfen zorunlu alanları doldurunuz", icon: "error" });
        } else {
            try {
                const data = JSON.stringify({
                    "id": currentId,
                    "rol": rol,
                    "yetkiler": yetkiListVerilen,
                });
            
                const result = await axios.post(settings.ApiUrl + 'Rol/InsertOrUpdateRol/', data, { headers: AuthService.getHeaders() });

                if (result) {
                    if (result.data.success) {
                        handleClose();
                        getData();
                        toast.success("Kaydedildi");
                    } else {
                        console.log(result.data);
                        toast.error("Hata oluştu: " + result.data.message);
                    }
                }
            } catch (error) {
                toast.error("Hata oluştu: " + error);
            }
        }
    }

    return (
        <Fragment>
            <Container>
                <ToastContainer position="bottom-right">
                </ToastContainer>
            </Container>
            
            <PageTitle></PageTitle>

            {
                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    yetkiGor !== null ?
                        yetkiGor === false ?
                            <div className="alert alert-danger">
                                Bu sayfaya erişim yetkiniz bulunmamaktadır
                            </div>
                            :
                            <div className="card info-card mb-2">
                                <table className="table table-bordered table-hover table-sm mb-0">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Rol</th>
                                            <th style={{textAlign:"center"}}>
                                                { yetkiEkle ? <button className="btn btn-sm btn-icon text-success" onClick={() => Ekle()}><i className="bi bi-plus-circle"></i></button> : '' }
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            data && data.length > 0 ?
                                                data.map((item, index) => {
                                                    return (
                                                        <tr key={item.id}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.rol}</td>
                                                            <td align="center">
                                                                { yetkiDegistir ? <button className="btn btn-sm btn-icon text-info" onClick={() => Degistir(item.id)}><i className="bi bi-pencil"></i></button> : '' }
                                                                { yetkiSil ? <button className="btn btn-sm btn-icon text-danger" onClick={() => Sil(item.id)}><i className="bi bi-trash3"></i></button> : '' }
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                                :
                                                <tr>
                                                    <td colSpan="3" align="center">
                                                        Kayıt yok
                                                    </td>
                                                </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        :
                        ""
            }

            <Modal show={show} onHide={handleClose} size="xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Rol Kaydı</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12 mb-3">
                            <div className="input-group input-group-sm">
                                <label id="lblRol" htmlFor="tbRol" className="input-group-text" style={{width:"120px"}}>Rol Adı<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                <input id="tbRol" aria-describedby="lblRol" type="text" className="form-control form-control-sm" value={rol} onChange={(e) => setRol(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <table className="w-100">
                                <tbody>
                                    <tr>
                                        <td width="46%">
                                            <div className="formControlBox">
                                                <div className="input-group input-group-sm" style={{padding:"3px"}}>
                                                    <input id="cbVerilebilecek" type="checkbox" checked={checkAllVerilmeyen} onChange={handleCheckAllVerilmeyen} className="form-check-input" style={{fontSize:"small"}}></input>
                                                    <label htmlFor="cbVerilebilecek" className="labelForCheckBoxOrRadio" style={{fontWeight: "bold"}}>Verilebilecek Yetkiler</label>
                                                </div>
                                                <div style={{overflowY: "auto", height: "400px"}}>
                                                    <table className="table table-hover table-sm table-borderless" style={{width:"auto"}}>
                                                        <tbody>
                                                            {
                                                                yetkiListVerilmeyen && yetkiListVerilmeyen.length > 0 ?
                                                                yetkiListVerilmeyen.map((item, index) => {
                                                                    return (
                                                                        <tr key={item.id}>
                                                                            <td>
                                                                                <input id={"cbVerilmeyen" + item.id} type="checkbox" className="form-check-input" checked={item.checked} onChange={() => yetkiListVerilmeyenOnUpdate(index, !item.checked)}></input>
                                                                            </td>
                                                                            <td>
                                                                                <label htmlFor={"cbVerilmeyen" + item.id} style={{cursor:"pointer"}}>{item.yetki}</label>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })
                                                                :
                                                                <tr>
                                                                    <td colSpan={2}>
                                                                    </td>
                                                                </tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </td>
                                        <td width="8%" align="center">
                                            <button className="btn btn-sm btn-primary" onClick={Saga}><i className="bi bi-arrow-right-short"></i></button>
                                            <br/>
                                            <br/>
                                            <button className="btn btn-sm btn-primary" onClick={Sola}><i className="bi bi-arrow-left-short"></i></button>
                                        </td>
                                        <td width="46%">
                                            <div className="formControlBox">
                                                <div className="input-group input-group-sm" style={{padding:"3px"}}>
                                                    <input id="cbVerilen" type="checkbox" className="form-check-input" checked={checkAllVerilen} onChange={handleCheckAllVerilen} style={{fontSize:"small"}}></input>
                                                    <label htmlFor="cbVerilen" className="labelForCheckBoxOrRadio" style={{fontWeight: "bold"}}>Verilen Yetkiler</label>
                                                </div>
                                                <div style={{overflowY: "auto", height: "400px"}}>
                                                    <table className="table table-hover table-sm table-borderless" style={{width:"auto"}}>
                                                        <tbody>
                                                            {
                                                                yetkiListVerilen && yetkiListVerilen.length > 0 ?
                                                                yetkiListVerilen.map((item, index) => {
                                                                    return (
                                                                        <tr key={item.id}>
                                                                            <td>
                                                                                <input id={"cbVerilen" + item.id} type="checkbox" className="form-check-input" checked={item.checked} onChange={() => yetkiListVerilenOnUpdate(index, !item.checked)}></input>
                                                                            </td>
                                                                            <td>
                                                                                <label htmlFor={"cbVerilen" + item.id} style={{cursor:"pointer"}}>{item.yetki}</label>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })
                                                                :
                                                                <tr>
                                                                    <td colSpan={2}>
                                                                    </td>
                                                                </tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-success" onClick={Kaydet}><i className="bi bi-check-lg mr-2"></i> Kaydet</button>
                    <button className="btn btn-secondary" onClick={handleClose}><i className="bi bi-x"></i> Vazgeç</button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default Rol;